import { ProviderModel } from './ProviderModel';

export class ConsolidationModel {
  numAnnoMese: string;
  provider: ProviderModel;

  constructor(numAnnoMese?: string, provider?: ProviderModel) {
          this.numAnnoMese = numAnnoMese;
          this.provider = this.provider;
  }
}
